import {
  BHAPTICS_COOKIE_OPTS,
  deleteCookieAllScopes,
} from "@/libs/locale/cookie";
import CountryUtils from "@/utils/CountryUtils";
import { getGlobalECurrency } from "@/libs/global-e/countries";
import type { LanguageCode } from "@/utils/LocaleUtil";
import { deleteCookie, setCookie } from "cookies-next";

// Global-E country/currency/culture 동기화 cookie.
// 정책: docs/global-e-storefront.md §3.5
// - 이름은 정확히 `GlobalE_Data` (대소문자 일치)
// - 호출은 GE 엔진이 있을 때만 (docs §3.5, 2026-10-12~): `GlobalEScripts`(엔진 주입 직전, 항상) +
//   setLocale(엔진이 이미 로드돼 있을 때 — reload 전). 엔진이 없는 곳(flag OFF · KR · webview)에서 쓰면
//   상위 도메인에 남아 다른 호스트(dev)의 엔진을 무한 재기록에 빠뜨린다. Global-E switcher UI 는 미사용.
// - country 무관 모두 set. KR 차단은 snippet 로드 가드·마커 가드가 맡는다 (§1.1, 2026-10-12~)
export const GLOBAL_E_DATA_COOKIE = "GlobalE_Data";

const TWO_MONTHS = 60 * 60 * 24 * 60;

const SET_OPTS = {
  ...BHAPTICS_COOKIE_OPTS,
  maxAge: TWO_MONTHS,
};

interface SyncArgs {
  countryCode: string;
  languageCode: LanguageCode;
}

export function syncGlobalEDataCookie({ countryCode, languageCode }: SyncArgs) {
  const upperCountry = countryCode.toUpperCase();
  const payload = {
    countryISO: upperCountry,
    // currency 는 GE DefaultCurrencyCode 기준(Browsing/Countries 캐시, 예: AU→"AUD"). 캐시에
    // 없으면 자체 매핑 fallback(비-KR/JP=USD — 부정확하나 안전망). docs/global-e-storefront.md §3.5
    currencyCode:
      getGlobalECurrency(countryCode) ??
      CountryUtils.convertCountryCodeToCurrency(countryCode),
    cultureCode: `${languageCode}-${upperCountry}`,
  };

  // 다른 스코프로 set된 동일 이름 쿠키 제거. GE 엔진은 `document.cookie` 의 **첫** `GlobalE_Data` 만
  // 읽는다 — 상위 `.bhaptics.com` 쿠키(prod 가 남긴 것)가 먼저 오면 엔진은 자기가 `.dev.bhaptics.com` 에
  // 쓴 값을 못 보고 무한 재기록한다(2026-10-12 dev 탭 멈춤). set 스코프(현재 host) 포함 전 스코프 정리.
  deleteCookieAllScopes(GLOBAL_E_DATA_COOKIE, deleteCookie);

  setCookie(GLOBAL_E_DATA_COOKIE, JSON.stringify(payload), SET_OPTS);
}
